import { hasEnv, Instance, getEnv, types } from "mobx-state-tree";

import { CbrfcAPI } from "./CbrfcAPI";
import { Layers } from "./Layers";
import { Menus } from "./Menus";
import { Sensors } from "./Sensors";
import { VaisalaAPI } from "./VaisalaAPI";
import { autorun } from "mobx";
import { useStore } from "mobx-store-provider";

const { model, number } = types;

const Map = model("Map", {
  zoom: number,
}).actions((self) => ({
  setZoom(zoom: number) {
    self.zoom = zoom;
  },
}));

const Root = model({
  vaisalaApi: VaisalaAPI,
  cbrfcApi: CbrfcAPI,
  sensors: Sensors,
  layers: Layers,
  menus: Menus,
  map: Map,
})
  .volatile((self) => ({
    isMobile: (hasEnv(self) && getEnv(self).mobile) || false,
  }))
  .actions((self) => ({
    updateWidth(width: number) {
      self.isMobile = width < 1024;
    },
  }))
  .actions((self) => ({
  afterCreate() {
      autorun(() => {
        const { panel } = self.menus;
        if (panel !== "layers") {
          self.layers.clearOpenLayerPanel();
        }
      });

      // Be smart about closing things on mobile
      autorun(() => {
        const { selected } = self.sensors;
        if (self.isMobile && selected !== undefined) {
          self.menus.closePanel();
        }
      });
      autorun(() => {
        const { panel } = self.menus;
        if (self.isMobile && panel !== undefined) {
          self.sensors.clearSensor();
        }
      });
    },
  }));

export default Root;
export interface IRoot extends Instance<typeof Root> {}

export const useRootStore = () => useStore(Root);
